module.exports = __webpack_public_path__ + "img/barrenado.63be90f9.png";